<template>
  <div style="width: 100%;height: 100%;overflow: auto">
    <div style="display: flex;margin-top: 10px;margin-left: 10px">
      <el-select v-model="year" style="width: 200px;" @change="initData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="company" style="width: 200px;margin-left: 10px" @change="initData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="margin-top: 10px;margin-left: 10px">
      <div style=" font-size: 18px"><b>SOLIDWORKS版本占比：</b></div>
      <div style="display: flex;height: 300px;margin-top: 20px">
        <div style="width: 29%;height: 100%" id="solidworksData"></div>
        <div style="width: 69%;height: 100%;" id="solidworksAccumulate"></div>
      </div>
    </div>

    <div style="margin-top: 20px;margin-left: 10px">
      <div style=" font-size: 18px"><b>SOLIDWORKS 335合同销售占比：</b></div>
      <div style="display: flex;height: 300px;margin-top: 20px">
        <div style="width: 29%;height: 100%" id="solidworks335Data"></div>
        <div style="width: 69%;height: 100%;" id="solidworks335Accumulate"></div>
      </div>
    </div>

    <div style="margin-top: 10px;margin-left: 10px">
      <div style=" font-size: 18px"><b>SOLIDWORKS 单套合同占比：</b></div>
      <div style="display: flex;height: 300px;margin-top: 20px">
        <div style="width: 29%;height: 100%" id="solidworksSingleData"></div>
        <div style="width: 69%;height: 100%;" id="solidworksSingleAccumulate"></div>
      </div>
    </div>



  </div>

</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "KeyIndicators",

  data() {
    return {
      year:'',
      yearList:[],
      company:'summaryData',
      companyList:[],

      solidworksFill:'#ff0000',
      solidworksData:[],
      solidworksAccumulateData:[],

      solidworks335Fill:'#ff0000',
      solidworks335Data:[],
      solidworks335AccumulateData:[],

      solidworksSingleFill:'#ff0000',
      solidworksSingleData:[],
      solidworksSingleAccumulateData:[],

    }
  },
  async created() {
    await this.getYearList();
    await this.getCompanyList();
    await this.initData();

  },

  methods:{
    async initData(){
      await this.getData();
      await this.renderEcharts();
      await this.render335Echarts();
      await this.renderSingleEcharts();
    },

    async getData(){
      let data = await this.$http('crmBusinessService.getKeyIndicatorData',{year:this.year,company:this.company});
      if(!data){
        return;
      }
      this.solidworksData = data.solidworksData;
      this.solidworksAccumulateData = data.solidworksAccumulateData;
      this.solidworksFill = data.solidworksData.fillColor;

      this.solidworks335Data = data.solidworks335Data;
      this.solidworks335AccumulateData = data.solidworks335AccumulateData
      this.solidworks335Fill = data.solidworks335Data.fillColor;

      this.solidworksSingleData = data.solidworksSingleData;
      this.solidworksSingleAccumulateData = data.solidworksSingleAccumulateData;
      this.solidworksSingleFill = data.solidworksSingleData.fillColor;
    },

    async getYearList(){
      const now = dayjs();
      this.year = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'summaryData',label:'汇总数据'})
      this.companyList = data;
    },

    async renderEcharts() {
      const solidworksChartDom = document.getElementById('solidworksData');
      const accumulateChartDom = document.getElementById('solidworksAccumulate');
      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(solidworksChartDom);
      // 获取现有的 ECharts 实例（如果有）
      let accumulateChart = echarts.getInstanceByDom(accumulateChartDom);
      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }
      // 如果存在现有的实例，销毁它
      if (accumulateChart) {
        accumulateChart.dispose();
      }
      // 初始化新的 ECharts 实例
      myChart = echarts.init(solidworksChartDom);
      myChart.setOption(this.getSolidworksChartOptions(), true);
      // 初始化新的 ECharts 实例
      accumulateChart = echarts.init(accumulateChartDom);
      accumulateChart.setOption(this.getAccumulateChartOptions(), true);
    },
    getSolidworksChartOptions(){
      return{
        title: {
          text: '实时数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        graphic: {
          // elements: [{ }]
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '白金版\n >60%',
            textAlign: 'center',
            fontSize: 25,
            fill: this.solidworksFill,
          },
        },
        label: {
          show: true, // 显示标签
          formatter: function (params) {
            // 计算占比
            const percent = ((params.value / params.data.total) * 100).toFixed(2);
            if(params.data.total === 0.0 || params.data.total === undefined){
              return '0%';
            }
            return `${percent}%`;
          }
        },
        series: this.solidworksData,
      }
    },
    getAccumulateChartOptions(){
      return{
        title: {
          text: '月度累计数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['标准版', '白金版', '专业版']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series:this.solidworksAccumulateData.map(item => ({
          ...item, // 保留原数据
          label: {
            show: true,
            position: 'top',
            formatter: function (params) {
              // 直接拼接 % 符号
              return `${params.value}%`;
            }
          }
        }))
      }
    },
    async render335Echarts() {
      const solidworksChartDom = document.getElementById('solidworks335Data');
      const accumulateChartDom = document.getElementById('solidworks335Accumulate');
      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(solidworksChartDom);
      // 获取现有的 ECharts 实例（如果有）
      let accumulateChart = echarts.getInstanceByDom(accumulateChartDom);
      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }
      // 如果存在现有的实例，销毁它
      if (accumulateChart) {
        accumulateChart.dispose();
      }
      // 初始化新的 ECharts 实例
      myChart = echarts.init(solidworksChartDom);
      myChart.setOption(this.get335ChartOptions(), true);
      // 初始化新的 ECharts 实例
      accumulateChart = echarts.init(accumulateChartDom);
      accumulateChart.setOption(this.get335AccumulateChartOptions(), true);
    },
    get335ChartOptions(){
      return{
        title: {
          text: '实时数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '335合同 \n >60%',
            textAlign: 'center',
            fontSize: 25,
            fill: this.solidworks335Fill,
          }
        },
        label: {
          show: true, // 显示标签
          formatter: function (params) {
            // 计算占比
            const percent = ((params.value / params.data.total) * 100).toFixed(2);
            if(params.data.total === 0.0 || params.data.total === undefined){
              return '0%';
            }
            return `${percent}%`;
          }
        },
        series: this.solidworks335Data,
      }
    },
    get335AccumulateChartOptions() {
      return {
        title: {
          text: '月度累计数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['非335合同', '335合同']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.solidworks335AccumulateData.map(item => ({
          ...item, // 保留原数据
          label: {
            show: true,
            position: 'top',
            formatter: function (params) {
              // 直接拼接 % 符号
              return `${params.value}%`;
            }
          }
        }))
      }
    },
    async renderSingleEcharts() {
      const solidworksChartDom = document.getElementById('solidworksSingleData');
      const accumulateChartDom = document.getElementById('solidworksSingleAccumulate');
      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(solidworksChartDom);
      // 获取现有的 ECharts 实例（如果有）
      let accumulateChart = echarts.getInstanceByDom(accumulateChartDom);
      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }
      // 如果存在现有的实例，销毁它
      if (accumulateChart) {
        accumulateChart.dispose();
      }
      // 初始化新的 ECharts 实例
      myChart = echarts.init(solidworksChartDom);
      myChart.setOption(this.getSingleChartOptions(), true);
      // 初始化新的 ECharts 实例
      accumulateChart = echarts.init(accumulateChartDom);
      accumulateChart.setOption(this.getSingleAccumulateChartOptions(), true);
    },

    getSingleChartOptions(){
      return{
        title: {
          text: '实时数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '单套订单 \n <15%',
            textAlign: 'center',
            fontSize: 25,
            fill: this.solidworksSingleFill, //'#ff0000'
          }
        },
        label: {
          show: true, // 显示标签
          formatter: function (params) {
            // 计算占比
            const percent = ((params.value / params.data.total) * 100).toFixed(2);
            if(params.data.total === 0.0 || params.data.total === undefined){
              return '0%';
            }
            return `${percent}%`;
          }
        },
        series: this.solidworksSingleData,
      }

    },
    getSingleAccumulateChartOptions() {
      return {
        title: {
          text: '月度累计数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['单套合同','多套合同']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.solidworksSingleAccumulateData.map(item => ({
          ...item, // 保留原数据
          label: {
            show: true,
            position: 'top',
            formatter: function (params) {
              // 直接拼接 % 符号
              return `${params.value}%`;
            }
          }
        }))
      }
    }

  }
}
</script>

<style scoped>

</style>